module.exports = __webpack_public_path__ + "assets/img/ArtyMirror_Belin.a044b71e-ps.jpg";